import React from "react";
import { useNavigate } from "react-router-dom";


export default function YoutubeGridScreen({ cards }) {
  const navigate = useNavigate();
  const navigateToLearnDetail = async (processId) => {
    console.log("processId LISY", processId);
    navigate(`/learn/${processId}`);
  };

  if (!cards || cards.length === 0) {
    return (
      <div className="pt-5">
          <p className="carousel-title ct-text-light ct-text-size-20-bold">All series</p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        textAlign: "left",
        margin: "48px 0 0 0",
        padding: "0 24px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: 30,
          paddingTop: 30,
        }}
      >
        <p className="ct-cirka-size-22 ct-text-light  m-0">All series</p>
      </div>
      <div className="youtube-scroll-grid">
        {cards.map((video, idx) => (
          <div
            key={idx}
            onClick={() => navigateToLearnDetail(video?.processId)}
            style={{
              borderRadius: 20,
              padding: 12,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src={video.image || video.thumbnail || video.img}
              alt={video.title}
              style={{
                width: "100%",
                borderRadius: 16,
                marginBottom: 12,
                aspectRatio: "3/4",
                objectFit: "cover",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
